<template>
  <ValidationObserver ref="obs" v-slot="{ invalid, handleSubmit }">
    <v-card class="elevation-0">
      <v-card-title
        class="pt-0 "
        v-if="getCountryParams.typeOfAccountsAvailable.length > 0"
      >
        {{ $t('create_account') }}
      </v-card-title>

      <alert :config="alertConfig"></alert>

      <v-stepper
        value="2"
        class="elevation-0"
        v-if="getCountryParams.typeOfAccountsAvailable.length > 0"
      >
        <v-stepper-header>
          <v-stepper-step
            step="1"
            @click.native="selectCountry"
            complete
            style="cursor: pointer"
          ></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2">{{ $t('account_type') }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3"></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4"></v-stepper-step>
        </v-stepper-header>
      </v-stepper>

      <v-card-title v-else>{{ $t('app_no_available') }}</v-card-title>

      <v-card-text>
        <VRadioGroupWithValidation
          v-if="getCountryParams.typeOfAccountsAvailable.length > 0"
          rules="required"
          v-model="accountType"
          :items="getCountryParams.typeOfAccountsAvailable"
        >
        </VRadioGroupWithValidation>

        <div v-else>
          <p class="text-h6 font-weight-light">
            {{ $t('subscribe_notify_app_available') }}
          </p>

          <VTextFieldWithValidation
            name="email"
            rules="required|email"
            v-model="email"
            prepend-icon="mdi-email-outline"
            :placeholder="$t('placeholders.email')"
            :label="`${$t('fields.email')} *`"
            @keyup.enter="handleSubmit(suscribe)"
            autofocus
          />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="getCountryParams.typeOfAccountsAvailable.length > 0"
          color="indigo lighten-5"
          @click="cancel"
          >{{ $t('cancel_registration') }}</v-btn
        >
        <v-btn v-else color="indigo lighten-5" @click="goBack">{{
          $t('no_thanks')
        }}</v-btn>

        <v-spacer></v-spacer>

        <submit-button
          v-if="getCountryParams.typeOfAccountsAvailable.length > 0"
          color="secondary"
          :loading="submitButtonLoading"
          @click="handleSubmit(next)"
          :disabled="invalid || submitButtonLoading"
          >{{ $t('continue') }}</submit-button
        >
        <submit-button
          v-else
          color="secondary"
          :loading="submitButtonLoading"
          @click="handleSubmit(suscribe)"
          :disabled="invalid || submitButtonLoading"
          >{{ $t('send') }}</submit-button
        >
      </v-card-actions>
      <v-card-actions>
        <span>
          {{ $t('have_account') }}
          <a v-on:click="signIn">{{ $t('sign_in') }}</a>
        </span>
      </v-card-actions>
      <v-card-actions>
        <span>
          {{ $t('forgot_password') }}
          <a v-on:click="forgot">{{ $t('reset_password') }}</a>
        </span>
      </v-card-actions>
    </v-card>
  </ValidationObserver>
</template>

<script>
import { formMixin } from '../../mixins/formMixin';

export default {
  name: 'account-type',
  mixins: [formMixin],
  data() {
    return {
      email: ''
    };
  },
  methods: {
    next() {
      this.$router.push({ path: '/organization-id' });
    },
    selectCountry() {
      this.$router.push({ path: '/select-country' });
    },
    signIn() {
      this.$router.push({ path: '/sign-in' });
    },
    forgot() {
      this.$router.push({ path: '/forgot-password' });
    },
    cancel() {
      this.$router.push({ path: '/home' });
    },
    suscribe() {}
  },
  computed: {
    accountType: {
      get() {
        return this.$store.getters['auth/accountType'];
      },
      set(value) {
        this.$store.dispatch('auth/setAccountType', value);
      }
    },
    getCountryParams() {
      return this.$store.getters['auth/getCountryParams'];
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/stepper';
</style>
